module.exports = __webpack_public_path__ + "static/media/cockroach(21).0a4b6f87.PNG";